module.exports = __webpack_public_path__ + "static/img/325.3bdbba62.png";